import React from "react";

/**
 * Catches render/runtime errors anywhere below it so a single component failure
 * shows a recoverable message instead of a blank white screen mid-study.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "2rem",
            textAlign: "center",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            color: "#1e293b",
          }}
        >
          <h1 style={{ fontSize: "1.4rem", margin: 0 }}>Something went wrong</h1>
          <p style={{ maxWidth: "38ch", color: "#475569", margin: 0 }}>
            An unexpected error interrupted the page. Please reload to continue
            where you left off. If this keeps happening, contact the study team.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "0.5rem",
              padding: "0.6rem 1.4rem",
              fontSize: "1rem",
              fontWeight: 600,
              color: "#fff",
              background: "#2563eb",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reload the page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
